import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Table, Tag } from "antd";
import { showConfirmDlgWidget } from "components/ConfirmDlgWidget/showConfirmDlgWidget";
import {
  money,
  PAYMENT_COLORS,
  STATUS_COLORS,
  STATUS_LABELS,
} from "../orderUtils";

function TableWidget(props) {
  const [dataSource, setDataSource] = useState([]);
  const { dataList, onViewAction, onDeleteAction } = props;

  useEffect(() => {
    if (dataList !== undefined) {
      setDataSource([...dataList.map((info) => ({ ...info, key: info.id }))]);
    }
  }, [dataList]);
  if (dataList === undefined) return <div />;

  const columns = [
    {
      title: "Order No",
      dataIndex: "order_no",
      render: (text) => <span style={{ fontWeight: 600 }}>{text}</span>,
    },
    {
      title: "Date",
      dataIndex: "add_timestamp",
      align: "center",
      sorter: {
        compare: (a, b) => (a.add_timestamp || "").localeCompare(b.add_timestamp || ""),
      },
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      render: (text, record) => (
        <div>
          <div>{record.customer_name}</div>
          <div style={{ color: "var(--darkGreyColor)", fontSize: 12 }}>
            {record.customer_email}
          </div>
        </div>
      ),
    },
    {
      title: "Items",
      dataIndex: "item_count",
      align: "center",
    },
    {
      title: "Total",
      dataIndex: "total",
      align: "right",
      sorter: {
        compare: (a, b) => Number(a.total || 0) - Number(b.total || 0),
      },
      render: (text, record) => (
        <span style={{ fontWeight: 600 }}>{money(record.total, record.currency)}</span>
      ),
    },
    {
      title: "Payment",
      dataIndex: "payment_status",
      align: "center",
      render: (text) => (
        <Tag color={PAYMENT_COLORS[text] || "default"}>{text || "-"}</Tag>
      ),
    },
    {
      title: "Status",
      dataIndex: "order_status",
      align: "center",
      render: (text) => (
        <Tag color={STATUS_COLORS[text] || "default"}>
          {STATUS_LABELS[text] || text || "-"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (text, record) => (
        <div>
          <a
            style={{ color: "var(--blueColor)", marginLeft: 12 }}
            onClick={() => onViewAction(record)}
          >
            View
          </a>
          <a
            style={{ color: "var(--redColor)", marginLeft: 16 }}
            onClick={async () => {
              const res = await showConfirmDlgWidget({
                title: "Delete Confirmation",
                content:
                  "Delete this order record? This does not refund the payment.",
              });
              if (res == false) return;
              onDeleteAction(record);
            }}
          >
            Delete
          </a>
        </div>
      ),
    },
  ];

  return (
    <div className="list-table">
      <Table pagination={false} columns={columns} dataSource={dataSource} />
    </div>
  );
}

export default withRouter(TableWidget);
